import request from '@/utils/request';

// 学校用户注册
export function registerSchoolInfo(data) {
  return request({
    url: '/subject/schoolInfo/register',
    method: 'post',
    data
  });
}

// 企业用户注册
export function registerCompanyInfo(data) {
  return request({
    url: '/subject/companyInfo/register',
    method: 'post',
    data,
  });
}

// 登录方法
export function login(username, password, code, uuid) {
  const data = {
    username,
    password,
    code,
    uuid
  }
  return request({
    url: '/login',
    headers: {
      isToken: false,
      repeatSubmit: false
    },
    method: 'post',
    data: data
  })
}


// 获取用户详细信息
export function getInfo() {
  return request({
    url: '/subject/reception/user/info',
    method: 'get',
  });
}

// 退出方法
export function logout() {
  return request({
    url: '/logout',
    method: 'post'
  })
}

// 获取验证码
export function getCodeImg() {
  return request({
    url: '/captchaImage',
    method: 'get'
  })
}

// 获取手机验证码
export function getPhoneCheckCode(phone) {
  return request({
    url: '/sms/code/' + phone,
    method: 'post'
  })
}